import { getMergeSortAnimations } from "../SortingVisualizer/MergeSortAlgorithm";
import classes from "../SortingVisualizer/SortingVisualizer.module.css";
function backtonormal() {
  const resetbtn = document.getElementById("reset_btn");
  const inputs = document.getElementById("inputs");
  const quicksort = document.getElementById("QuickSort");
  const mergesort = document.getElementById("MergeSort");
  const bubblesort = document.getElementById("BubbleSort");
  const insertionsort = document.getElementById("InsertionSort");
  quicksort.classList.remove(`${classes.disable}`);
  mergesort.classList.remove(`${classes.selected}`);
  bubblesort.classList.remove(`${classes.disable}`);
  insertionsort.classList.remove(`${classes.disable}`);
  inputs.classList.remove(`${classes.disable}`);
  resetbtn.classList.remove(`${classes.disable}`);
}
export default async function mergeSort({ array, speed }) {
  const PRIMARY_COLOR = "turquoise";
  const SECONDRY_COLOR = "red";
  const ANNIMATION_S = Math.floor(100 - 2 * speed);
  const animations = getMergeSortAnimations(array);

  for (let i = 0; i < animations.length; i++) {
    const arrayBars = document.getElementsByClassName("array-bar");
    const isColorChange = i % 3 !== 2;
    if (isColorChange) {
      const [barOneIdx, barTwoIdx] = animations[i];
      const barOneStyle = arrayBars[barOneIdx].style;

      const barTwostyle = arrayBars[barTwoIdx].style;
      const color = i % 3 === 0 ? SECONDRY_COLOR : PRIMARY_COLOR;
      setTimeout(() => {
        barOneStyle.backgroundColor = color;
        barTwostyle.backgroundColor = color;
      }, i * ANNIMATION_S);
    } else {
      setTimeout(() => {
        const [barOneIdx, newHeight] = animations[i];
        const barOneStyle = arrayBars[barOneIdx].style;
        barOneStyle.height = `${newHeight}px`;
        if (i === animations.length - 1) {
        }
        if (i === animations.length - 1) {
          backtonormal();
        }
      }, i * ANNIMATION_S);
    }
  }
}
